export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
// The trader portal, opened with an impersonation token for "view as trader"
export const PORTAL_URL = process.env.REACT_APP_PORTAL_URL || "http://localhost:3001";
const TOKEN_KEY = "pf_admin_token";

// Fired when the API rejects the stored token, so App can drop the session
export const UNAUTHORIZED_EVENT = "pf-admin-unauthorized";

export const ADMIN_ROLES = ["admin", "superadmin"];

export function readToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function storeToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // Storage blocked (private mode etc.) – the session just won't persist
  }
}

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

// ?key=value for every entry that's set
function queryString(query) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query ?? {})) {
    if (value !== null && value !== undefined && value !== "") params.set(key, value);
  }
  const string = params.toString();
  return string ? `?${string}` : "";
}

// JSON request to the portal API with the stored admin token. Resolves to the parsed
// body; rejects with an ApiError carrying the API's `error` message.
export async function apiRequest(path, { method = "GET", query, body, signal } = {}) {
  const token = readToken();
  let res;
  try {
    res = await fetch(`${API_URL}${path}${queryString(query)}`, {
      method,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
      signal,
    });
  } catch (err) {
    if (err.name === "AbortError") throw err;
    throw new ApiError("Couldn't reach the server. Check your connection and try again.", 0);
  }

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 && token) {
      window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
    }
    throw new ApiError(json.error || "Something went wrong. Please try again.", res.status);
  }
  return json;
}

// The API's public user → the shape the sidebar and pages use
export function toSessionUser(user) {
  return { id: user.id, name: user.username || user.email, email: user.email, role: user.role };
}
